import { ContactSectionProps } from '@/src/sections/contact/v1';

export const contactSectionData: ContactSectionProps = {
  sectionHeading: {
    subtitle: 'Get a Personalized Quote',
    title: 'Let’s Talk Tech ',
  },
  image: {
    src: '/assets/images/contact/section-half-bg-1.png',
    alt: 'contact section background image',
  },
};
